import styled from 'styled-components'

export const FirstStepIframe = styled.iframe`
  width: 100%;
  min-height: calc(100vh - 86px);
  padding-left: 79px;
`
